import { Link, Outlet, createRootRoute } from '@tanstack/react-router';
import { JobsSidebar, useNavigationGuard } from '@/shared/jobs';
import { useSchedulerBootstrap } from '@/shared/jobs/useSchedulerBootstrap';
import { cn } from '@/shared/lib/cn';

function RootLayout() {
  useSchedulerBootstrap();
  useNavigationGuard();

  return (
    <div className="flex min-h-screen flex-col">
      <header className="border-b border-border bg-background/80 backdrop-blur">
        <nav className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
          <Link to="/" className="text-base font-semibold">
            Brand Generator
          </Link>
          <div className="flex items-center gap-4 text-sm">
            <NavLink to="/brands">Brands</NavLink>
            <NavLink to="/settings">Settings</NavLink>
          </div>
        </nav>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-4 py-8">
        <Outlet />
      </main>
      <footer className="border-t border-border px-4 py-6 text-xs text-muted-foreground">
        <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-between gap-3">
          <span className="font-mono uppercase tracking-widest">
            © {new Date().getFullYear()} Brand Generator
          </span>
          <nav className="flex gap-5">
            <Link to="/imprint" className="hover:text-foreground">
              Imprint
            </Link>
            <Link to="/privacy" className="hover:text-foreground">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-foreground">
              Terms
            </Link>
          </nav>
        </div>
      </footer>
      <JobsSidebar />
    </div>
  );
}

function NavLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      className={cn('text-muted-foreground transition-colors hover:text-foreground')}
      activeProps={{ className: 'text-foreground font-medium' }}
    >
      {children}
    </Link>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
});
